import React from 'react';
import Box from '@mui/material/Box';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';
import { useTranslation } from 'react-i18next';

export type CheckBoxType = {
  value: string | undefined;
  label: string | number | React.ReactElement | undefined;
  selected: boolean;
};

interface CheckboxGroupProps {
  data: CheckBoxType[] | undefined;
  onChange: (checkboxes: CheckBoxType[] | undefined) => void;
  label?: string;
}

export const CheckboxGroup = ({
  data,
  onChange,
  label,
}: CheckboxGroupProps) => {
  const [state, setState] = React.useState(data);

  const { t } = useTranslation();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newCheckboxes = state?.map((s) => {
      if (event.target.name === s.value) {
        return {
          ...s,
          selected: event.target.checked,
        };
      } else {
        return s;
      }
    });

    setState(newCheckboxes);

    onChange(newCheckboxes);
  };

  const renderCheckboxes = () => {
    return state?.map((d) => {
      return (
        <FormControlLabel
          key={d.value}
          control={
            <Checkbox
              checked={d.selected}
              onChange={handleChange}
              name={d.value}
              sx={{
                color: '#38A7B4',
                '&.Mui-checked': {
                  color: '#38A7B4',
                },
              }}
            />
          }
          label={t(`inputs.labels.${d.label}`, { defaultValue: d.label })}
          sx={{
            '&.MuiFormControlLabel-root .MuiTypography-root': {
              fontFamily: 'Tajawal !important',
            },
          }}
        />
      );
    });
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <FormControl
        sx={{
          mx: 2,
          '&.MuiFormControl-root': {
            margin: 0,
          },
        }}
        component="fieldset"
        variant="standard"
      >
        <FormLabel component="legend">
          <ReturnTranslatedText
            text={`inputs.labels.${label}`}
            origintext={label}
          />
        </FormLabel>
        <FormGroup>{renderCheckboxes()}</FormGroup>
      </FormControl>
    </Box>
  );
};
